import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceLogOutNotificationState = createStateReducer(initialState, {
  [events.logOutFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "logOut",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceLogOutNotificationState };
